import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'

import { permissionGuard } from '@core/guards/permission.guard'
import { PermissionsSource } from '@core/types/permissions.source'
import { MessengerComponent } from '@app/modules/client/messenger/components/messenger/messenger.component'
import { ChatDetailsComponent } from '@app/modules/client/messenger/components/chat-details/chat-details.component'
import { ChatCreateButtonComponent } from './components/chat-create-button/chat-create-button.component'

const routes: Routes = [
  {
    path: '',
    component: MessengerComponent,
    canActivate: [permissionGuard],
    data: { permissionGuard: PermissionsSource.MESSENGER },
    children: [
      {
        path: ':id',
        component: ChatDetailsComponent,
      },
      {
        path: '',
        pathMatch: 'full',
        component: ChatCreateButtonComponent,
      },
    ],
  },
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MessengerRoutingModule {}
